module.exports = __webpack_public_path__ + "img/medal_subscription_active.e791373e.png";